import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FileUp } from "lucide-react";
import AddFileForm from "../forms/AddFileForm";
import { KnowledgeItem } from "@/services/fileService";

interface FileUploadModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: (item?: KnowledgeItem) => void;
  agentId?: string | null;
}

const FileUploadModal = ({ open, onOpenChange, onSuccess, agentId }: FileUploadModalProps) => {
  const handleSuccess = (item?: KnowledgeItem) => {
    if (onSuccess) {
      onSuccess(item);
    } else {
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileUp className="h-5 w-5 text-blue-600" />
            Upload File to Knowledge Base
          </DialogTitle>
          <DialogDescription>
            Upload documents, PDFs, or text files to make them searchable by {agentId ? "your agent" : "all agents in your organization"}
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4">
          <AddFileForm onSuccess={handleSuccess} agentId={agentId} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FileUploadModal; 